import { DriverStep } from '../types/DriverStep'

export const layoutTourSteps: DriverStep[] = [
  {
    element: '#primary-nav-active-group',
    popover: {
      title: 'Active Group Dropdown',
      description: 'Click to change the current active group. A group is a collection of resources or users under a region or a business unit.',
    },
  },
  {
    element: '#primary-nav-operations',
    popover: {
      title: 'Operations',
      description: `Manage your daily operations by:<br/>
      • Plan and schedule your incoming orders<br/>
      • Create and manage scenarios and runsheets<br/>
      • Track your runs<br/>
      • View and optimize your routes`,
    },
  },
  {
    element: '#primary-nav-import',
    popover: {
      title: 'Import Wizard',
      description: 'Import orders and scenarios from an excel file. The structure of the file must match the template provided.',
    },
  },
  {
    element: '#primary-nav-admin',
    popover: {
      title: 'Admin',
      description: 'Manage your organisation users, groups, and resources like runs, depots, and drivers.',
    },
  },
  {
    element: '#primary-nav-settings',
    popover: {
      title: 'Settings',
      description: 'Change color mode and logout.',
    },
  },
  
]